import { EmailContactEntity } from '../contact/contact.options';
import { Entity } from '../entity';

export enum PolicyOptionVisibility {
    Disabled = 'Disabled',
    Required = 'Required',
    Optional = 'Optional'
}

export interface PolicyNotification<T extends String> {
    _id: string;
    active: boolean;
    type: T,
    email: boolean;
    emailTo: EmailContactEntity[];
    emailMessage: string;
    emailSubject: string;
    sms: boolean;
    smsFrom: string;
    smsTo: string[];
    smsMessage: string;
}


export interface Policy extends Entity {
    _id: string;
    isDefault: boolean;
    __v?: number;
    createdBy: Entity;
    updatedBy: Entity;
}

export const defaultPolicyNotification: PolicyNotification<any> = {
    _id: null,
    active: true,
    type: null,
    email: true,
    emailTo: [],
    emailMessage: '',
    emailSubject: '',
    sms: false,
    smsFrom: '',
    smsTo: [],
    smsMessage: '',
}
